import styled from "styled-components";


export const SignupNavdiv  = styled.div`
width:100%;
height:80px;
display:flex
` 

export const SignupNavdivLogoDiv = styled.div`
flex-basis:20%;
float: left;
`

export const Signupformdiv = styled.div`
width:30%;
height: 70vh;
margin:auto;
margin-top:3%;
background-color: #fff;
box-shadow:0 0 20px rgb(0 0 0 / 10%);
display:flex;
border-radius:5px;
flex-direction: column;
`